import { Box } from 'grid'
import { Icon, IIconProps } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTheme } from 'theme'

export type MailIconProps = Omit<IIconProps, 'iconName' | 'styles'> & {
  value?: number
}

export const MailIcon: React.FC<MailIconProps> = (props) => {
  const theme = useTheme()
  return (
    <Icon
      iconName="Mail"
      styles={{ root: { color: theme.palette.redDark } }}
      {...props}
    />
  )
}

export const MailYesNoIcon: React.FC<MailIconProps> = ({ value, ...props }) => {
  return value && value > 0 ? (
    <Box>
      <MailIcon {...props} /> {value}
    </Box>
  ) : (
    <Box />
  )
}
